import PropTypes from 'prop-types';

import { BrandPropTypes } from '@/common/proptypes/Common/Brand/Brand.proptypes';
import { FlagsPropTypes } from '@/common/proptypes/Common/Flags/Flags.proptypes';
import { ImagePropTypes } from '@/common/proptypes/Common/Image/Image.proptypes';
import { PricesAndStocksPropTypes } from '@/common/proptypes/PricesAndStocks/PricesAndStocks.proptypes';

export const CartItemDefaultProps = {
  discount_label: null,
  discount_price: null,
  id: null,
  invoice_unit: null,
  is_salable: false,
  is_selected: false,
  is_substitute: false,
  line_subtotal: null,
  price: null,
  product: {},
  quantity: null,
  quote_number: null,
  sale_unit: null,
  sku: null,
  substitute: null,
  weee_amount: null,
  weee_total_amount: null,
};

export const CartItemPropTypes = {
  discount_label: PropTypes.string,
  discount_price: PropTypes.number,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  invoice_unit: PropTypes.string,
  is_salable: PropTypes.bool,
  is_selected: PropTypes.bool,
  is_substitute: PropTypes.bool,
  line_subtotal: PropTypes.number,
  price: PropTypes.number,
  product: PropTypes.shape({
    ...BrandPropTypes,
    ...FlagsPropTypes,
    ...ImagePropTypes,
    agrement_fgaz: PropTypes.string,
    company_availability: PropTypes.bool,
    main_sku: PropTypes.string,
    manufacturer_sku: PropTypes.string,
    must_substitute: PropTypes.bool,
    name: PropTypes.string,
    path: PropTypes.string,
    price_and_stock: PropTypes.shape({
      ...PricesAndStocksPropTypes,
    }),
    sku: PropTypes.string,
    slug: PropTypes.string,
  }),
  quantity: PropTypes.number,
  quote_number: PropTypes.number,
  sale_unit: PropTypes.string,
  sku: PropTypes.string,
  substitute: PropTypes.string,
  weee_amount: PropTypes.number,
  weee_total_amount: PropTypes.number,
};
